module.exports = __webpack_public_path__ + "static/media/guilt.af12a7d8.png";